import React from 'react';
import Work1 from '../../assets/buySellWeb.png'
import Work2 from '../../assets/rateUs.png'
import Work3 from '../../assets/EdTech.png'
import ProjectDetails from './ProjectDetails';


const Projects = () => {
    const projectsData = [
        {
            id: 1,
            image: Work1,
            title: "BuySellRepeat",
            description: "Full-Stack MERN Projects",
            link: "https://assignment-12-9aa5e.web.app/",
            go: "/project1"
        },
        {
            id: 2,
            image: Work2,
            title: "RateUs",
            description: "Full-Stack MERN Projects",
            link: "https://assignment-11-f6512.web.app/",
            go: "/project2"

        },
        {
            id: 3,
            image: Work3,
            title: "EdTech",
            description: "Front-End Projects",
            link: "https://edtech-assignmnet.web.app/course",
            go: "/project3"

        }
    ];
    return (
        <div>
            <h1 className='text-3xl font-bold text-center pt-5'>My Projects</h1>
            {/* <h1 className='text-xs font-bold text-left pt-5 text-base-200'>Recent Works</h1> */}
            <div className='grid lg:grid-cols-3 mid:grid-cols-2 grid-cols-1 mt-10'>
                {
                    projectsData.map(project => <ProjectDetails
                        key={project.id}
                        project={project}
                    >
                    </ProjectDetails>)
                }
            </div>
        </div>
    );
};

export default Projects;